import { Component, OnInit, ViewChild, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAccountPersonRequest, PaymentMethod, RIQPaymentRequest } from 'src/app/models/PaymentModels';
import { NgForm } from '@angular/forms';
import { PaymentsService } from 'src/app/services/payments.service';
import { ToastrService } from 'ngx-toastr';
import { ChannelEvent, ChannelService } from 'src/app/services/channel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AssignPaymentMethodComponent } from '../assign-payment-method/assign-payment-method.component';
import { AddPaymentMethodComponent } from '../add-payment-method/add-payment-method.component';
import { ClientInvoiceRow, InvoiceHistoryModel } from 'src/app/models/InvoiceHistoryModels';
import { PaymentMethodListComponent } from '../payment-method-list/payment-method-list.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-one-time-payment-draft',
  templateUrl: './one-time-payment-draft.component.html',
  styleUrls: ['./one-time-payment-draft.component.less']
})
export class OneTimePaymentDraftComponent implements OnInit, AfterViewInit {

  @Input() clientId: number;
  @Input() propertyId: number;
  @Input() amount: number;
  @Input() draftId: number;
  @Output() paymentProcessed: EventEmitter<boolean> = new EventEmitter();
  @Output() paymentCancel: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('PmtForm', {}) pmtForm: NgForm;
  aptexxCreatePaymentLink: string;
  selectedPmtMethod: PaymentMethod;
  showButtons: boolean = true;
  currentStage: OneTimePaymentFlowPage = OneTimePaymentFlowPage.SelectMethod;
  paymentRequest: RIQPaymentRequest = new RIQPaymentRequest();
  paymentResponse: any;
  public get selectedPmtMethodId(): number {
    if (!this.selectedPmtMethod) return 0;
    return this.selectedPmtMethod.id;
  }


  constructor(public modalService: NgbModal, public payments: PaymentsService, private toast: ToastrService, public sanitizer: DomSanitizer) { }
  ngAfterViewInit(): void {
    this.payments.LoadUserPaymentMethods(this.propertyId,this.clientId);
  }

  ngOnInit() {
    
  }

  cancel(): void {
    this.payments.processing = false;
    this.modalService.dismissAll();
  }

  save(): void {
    if (this.currentStage == OneTimePaymentFlowPage.SelectMethod) {
      if (this.payments.paymentMethods.filter(pmt => { return pmt.selected; }).length == 0) {
        this.toast.error('Please select a payment method to make your payment');
        return;
      }
      this.paymentRequest.accountPersonId = this.selectedPmtMethod.vendorAccountId;
      this.paymentRequest.amount = Math.round(this.amount * 100);
      this.paymentRequest.methodId = this.selectedPmtMethod.methodId;
      this.currentStage = OneTimePaymentFlowPage.VerifyPaymentDetails;

    } else if (this.currentStage == OneTimePaymentFlowPage.VerifyPaymentDetails) {
      if(!this.pmtForm.valid) {
        this.toast.error('Please provide atleast 1 recipient email address to continue.');
        return;
      }
      this.paymentRequest.screeningDraftId = this.draftId;
      this.payments.sendPayment(this.paymentRequest).subscribe((rsp: any) => {
        this.paymentResponse = rsp;
        this.payments.processing = false;
        this.showButtons = false;
        this.currentStage = OneTimePaymentFlowPage.PaymentSummary;
        if(this.paymentResponse.success) this.paymentProcessed.next(true);
      });
    }

  }
  toggleMethod(pmt: PaymentMethod){
    this.selectedPmtMethod = pmt;
  }

  tryAgain(){
    this.selectedPmtMethod = undefined;
    this.showButtons = true;
    this.paymentRequest = new RIQPaymentRequest();
    this.currentStage = OneTimePaymentFlowPage.SelectMethod;
  }

  fireGuestPmt(){
    this.paymentCancel.next();
  }
}

export enum OneTimePaymentFlowPage {
  SelectMethod,
  AddMethod = 1,
  AssignMethod = 2,
  VerifyPaymentDetails = 3,
  PaymentSummary = 4
}
